
const url = 'dashboard';

export const dashboardRoutes = {
  main: `/admin/${url}`,
};
